import { useUserDetailsState } from "features/Header/PuzzelTelephone/provider/contexts/UserDetailsAndLogOnOffContext";
import CallAllocated from "features/Header/PuzzelTelephone/components/CallControl/views/CallAllocated";
import { TransferProvider } from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/TransferProvider";
import CallOut from "features/Header/PuzzelTelephone/components/CallControl/views/CallOut";
import CallInSession from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallInSession";

const CallControl = () => {
  const userDetails = useUserDetailsState();

  if (!userDetails.isLoggedOn) return null;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <CallAllocated />
      <TransferProvider>
        <CallInSession />
      </TransferProvider>
      <CallOut />
    </div>
  );
};

export default CallControl;
